<template>
    <div class="arrange-set">
        <div class="arrange-actions" v-if="$store.state.user.rank==1">
            <Button type="primary" icon="md-add" @click="addModal.show=true" class="margin-r10 shadow112006">{{$t('a_addClass')}}</Button>
            <Button type="info" icon="md-archive" class="shadow112006">{{$t('a_saveClass')}}</Button>
        </div>
        <!-- table -->
        <Table border stripe ref="selection" :columns="columns" :data="Arranges" height="873"/>
        <!-- 底部分页 -->
        <ArrangeFooter></ArrangeFooter>
        <!-- 添加排班 -->
        <Modal v-model="addModal.show" @on-ok="doAdd" @on-cancel="addModal.show = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')" width="300">
            <p slot="header">
                <Icon type="md-add"/>
                <span>{{$t('a_addClass')}}</span>
            </p>
            <Form :model="addModal.params" :label-width="80">
                <FormItem :label="$t('a_className')">
                    <Input v-model="addModal.params.name" :placeholder="$t('a_className')"/>
                </FormItem>
                <FormItem :label="$t('a_workingHours')">
                    <TimePicker v-model="addModal.params.start" format="HH:mm:ss" :placeholder="$t('a_workingHours')" :steps="[1, 5, 60]" :editable="false"></TimePicker>
                </FormItem>
                <FormItem :label="$t('a_afterWorkingHours')" style="margin-bottom:0px;">
                    <TimePicker v-model="addModal.params.end" format="HH:mm:ss" :placeholder="$t('a_afterWorkingHours')" :steps="[1, 5, 60]" :editable="false"></TimePicker>
                </FormItem>
            </Form>
        </Modal>
        <!-- 编辑排班 -->
        <Modal v-model="editModal.show" @on-ok="doEdit" @on-cancel="editModal.show = false" :ok-text="$t('ok')" :cancel-text="$t('cancel')" width="300">
            <p slot="header">
                <Icon type="md-settings"/>
                <span>{{$t('a_editClass')}}</span>
            </p>
            <Form :model="editModal.params" :label-width="80">
                <FormItem :label="$t('a_className')">
                    <Input v-model="editModal.params.wt_name" :placeholder="$t('a_className')"/>
                </FormItem>
                <FormItem :label="$t('a_workingHours')">
                    <TimePicker v-model="editModal.params.start" format="HH:mm:ss" :placeholder="$t('a_workingHours')" :steps="[1, 5, 60]" :editable="false"></TimePicker>
                </FormItem>
                <FormItem :label="$t('a_afterWorkingHours')" style="margin-bottom:0px;">
                    <TimePicker v-model="editModal.params.end" format="HH:mm:ss" :placeholder="$t('a_afterWorkingHours')" :steps="[1, 5, 60]" :editable="false"></TimePicker>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
import ArrangeFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment from 'moment';

export default {
    components: {
        ArrangeFooter
    },
    data() {
        let columns = [
            {
                type: 'index',
                width: 60,
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_className'));
                },
                key: 'wt_name',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_workingTime'));
                },
                key: 'wt_range',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('action'));
                },
                align: 'center',
                width: 200,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.editModal.params = Object.assign({}, params.row);
                                        this.editModal.show = true;
                                    }
                                }
                            },
                            this.$t('edit')
                        ),
                        h(
                            'Button',
                            {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            title: this.$t('a_deleteClass'),
                                            content: `${this.$t('a_sureDeleteClass')}：${params.row.wt_name}？？？`,
                                            onOk: () => {
                                                this.doDel(params.row.wt_id);
                                            }
                                        });
                                    }
                                }
                            },
                            this.$t('delete')
                        )
                    ]);
                }
            }
        ];
        if (this.$store.state.user.rank != 1) {
            columns.pop();
        }
        return {
            columns,
            Arranges: [], // 排班列表
            addModal: {
                show: false,
                params: {
                    cid: this.$store.state.user.cid,
                    name: '',
                    start: '',
                    end: ''
                }
            },
            editModal: {
                show: false,
                params: {}
            }
        };
    },
    created() {
        this.$store.commit('upNavbar', 10);
    },
    mounted() {
        this.getArranges(); // 获取车间列表
    },
    methods: {
        // 获取排班列表信息
        getArranges() {
            Axios.get(AxiosUrl.worktime.list, {
                params: {
                    cid: this.$store.state.user.cid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    var data = res.data.data;
                    data.forEach(el => {
                        var startArr = el.wt_start.split(':');
                        var endArr = el.wt_end.split(':');
                        el.start = Moment('00:00:00', 'HH:mm:ss')
                            .add({ hours: startArr[0], minutes: startArr[1], seconds: startArr[2] })
                            .format('HH:mm:ss');
                        el.end = Moment('00:00:00', 'HH:mm:ss')
                            .add({ hours: endArr[0], minutes: endArr[1], seconds: endArr[2] })
                            .format('HH:mm:ss');
                        el.wt_range = `${el.start} -- ${el.end}`;
                    });
                    this.Arranges = data;
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 添加排班
        doAdd() {
            var startArr = this.addModal.params.start.split(':');
            var startH = parseInt(startArr[0]);
            var nextDay = false; //用来标识整班都跨天
            if (startH <= 5) {
                startArr[0] = startH + 24;
                this.addModal.params.start = startArr.join(':');
                nextDay = true;
            }
            if (Moment(this.addModal.params.start, 'HH:mm:ss') > Moment(this.addModal.params.end, 'HH:mm:ss') || nextDay) {
                var endArr = this.addModal.params.end.split(':');
                endArr[0] = parseInt(endArr[0]) + 24;
                this.addModal.params.end = endArr.join(':');
            }
            Axios.get(AxiosUrl.worktime.add, {
                params: this.addModal.params
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('addSuccess'));
                    this.addModal.params.name = '';
                    this.addModal.params.start = '';
                    this.addModal.params.end = '';
                    this.getArranges();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        // 删除排班
        doDel(wt_id) {
            Axios.get(AxiosUrl.worktime.del, {
                params: {
                    cid: this.$store.state.user.cid,
                    wt_ids: wt_id
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('deleteSuccess'));
                    this.getArranges();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        },
        //编辑排班
        doEdit() {
            var startArr = this.editModal.params.start.split(':');
            var startH = parseInt(startArr[0]);
            var nextDay = false; //用来标识整班都跨天
            if (startH <= 5) {
                startArr[0] = startH + 24;
                this.editModal.params.start = startArr.join(':');
                nextDay = true;
            }
            if (Moment(this.editModal.params.start, 'HH:mm:ss') > Moment(this.editModal.params.end, 'HH:mm:ss') || nextDay) {
                var endArr = this.editModal.params.end.split(':');
                endArr[0] = parseInt(endArr[0]) + 24;
                this.editModal.params.end = endArr.join(':');
            }
            Axios.get(AxiosUrl.worktime.edit, {
                params: {
                    cid: this.$store.state.user.cid,
                    wt_id: this.editModal.params.wt_id,
                    name: this.editModal.params.wt_name,
                    start: this.editModal.params.start,
                    end: this.editModal.params.end
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('updateSuccess'));
                    this.getArranges();
                } else {
                    this.$Message.error(res.data.msg);
                }
            });
        }
    }
};
</script>
<style lang="less">
.arrange-actions {
    position: fixed;
    top: 90px;
    left: 95px;
    right: 0;
    z-index: 97;
    // height: 75px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding: 15px 10px 15px 15px;
    background-color: #d7d7d7;
}
</style>




// WEBPACK FOOTER //
// src/views/system/arrange.vue